import {
  LegacyCard,
  Checkbox,
  HorizontalGrid,
  FooterHelp,
  Form,
  Layout,
  Page,
  SkeletonPage,
  Text,
  TextField,
  VerticalStack,
} from '@shopify/polaris';
import { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import ToastContext from '../../../context/ToastContext';
import { SET_ERROR, SET_OK } from '../../../context/ToastReducer';
import { deleteRole, editRoleById, getRoleById, listPermissions } from '../../../services/rolesService';

const EditRole = () => {
  const { id } = useParams();
  const history = useHistory();
  const [, dispatchToast] = useContext(ToastContext);
  const returnMatch = window.location.search.match(/\??r=(.+)&?/);
  const returnUrl = returnMatch && returnMatch.length > 1 ? window.atob(returnMatch[1]) : '/roles';

  const [role, setRole] = useState(null);
  const [edit, setEdit] = useState({});
  const [permissions, setPermissions] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    Promise.all([getRoleById(id), listPermissions()]).then(([r, p]) => {
      setRole(r.data);
      setEdit(r.data);
      setPermissions(p.data.permissions);
      if (r.data.slug === 'admin') {
        setIsAdmin(true);
      }
    });
    // eslint-disable-next-line
  }, []);

  const handleDeleteRole = () =>
    window.confirm('¿Estás seguro de que quieres eliminar este rol?') &&
    deleteRole(id)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: r.data });
        history.push(returnUrl);
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });

  const handleChange = (permit) => {
    const newPermits = edit.permissions.includes(permit)
      ? edit.permissions.filter((p) => p !== permit)
      : [...edit.permissions, permit];
    setEdit({ ...edit, permissions: newPermits });
  };

  const handleSubmit = () => {
    editRoleById(id, edit)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: { message: 'Datos cambiados' } });
        history.push(returnUrl);
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });
  };

  return <>
    {!role && <SkeletonPage title="Cargando..."></SkeletonPage>}
    {role && (
      <>
        <Page
          title={role.name}
          subtitle="Editar rol"
          primaryAction={{
            content: 'Guardar',
            onAction: handleSubmit,
          }}
          secondaryActions={[
            {
              content: 'Eliminar',
              onAction: handleDeleteRole,
              destructive: true,
            },
          ]}
          backAction={{
            content: 'Roles',
            url: returnUrl,
          }}
          divider
        >
          <Layout>
            <Form onSubmit={handleSubmit}>
              <Layout.AnnotatedSection
                title="Datos del rol"
                description="El slug es el identificador único del rol y no se puede cambiar"
              >
                <LegacyCard>
                  <LegacyCard.Section>
                    <TextField
                      label="Nombre"
                      type="text"
                      placeholder="Nombre del rol"
                      value={edit.name}
                      onChange={(e) => setEdit({ ...edit, name: e })}
                    />
                  </LegacyCard.Section>
                  <LegacyCard.Section>
                    <TextField
                      label="Slug"
                      value={edit.slug}
                      onChange={(e) => setEdit({ ...edit, slug: e })}
                      type="text"
                      disabled={true}
                    />
                  </LegacyCard.Section>
                </LegacyCard>
              </Layout.AnnotatedSection>
              <Layout.AnnotatedSection
                title="Permisos de usuario"
                description="Selecciona los permisos que tendrá este rol"
              >
                <LegacyCard>
                  {isAdmin && (
                    <LegacyCard.Section>
                      <Text variant="headingXl">Este rol cuenta con todos los permisos</Text>
                    </LegacyCard.Section>
                  )}
                  {!isAdmin &&
                    permissions.map((permission, k) => (
                      <LegacyCard.Section key={k} title={permission.description}>
                        <HorizontalGrid gap="4" columns={6}>
                          {permission.permissions.map((p, kk) => (
                            <Checkbox
                              key={kk}
                              label={p}
                              checked={edit.permissions.includes(`${permission.domain}:${p}`)}
                              onChange={() => handleChange(`${permission.domain}:${p}`)}
                              disabled={isAdmin}
                            />
                          ))}
                        </HorizontalGrid>
                      </LegacyCard.Section>
                    ))}
                </LegacyCard>
              </Layout.AnnotatedSection>
            </Form>
          </Layout>
        </Page>
        <FooterHelp>
          <VerticalStack gap={2}>
            <p>
              <small>
                Creado el {edit.createdAt && new Date(edit.createdAt).toLocaleString('es-ES')} | Última modificación:{' '}
                {edit.updatedAt && new Date(edit.updatedAt).toLocaleString('es-ES')}
              </small>
            </p>
          </VerticalStack>
        </FooterHelp>
      </>
    )}
  </>;
};

export default EditRole;
